import { useState } from 'react';
import { supabase } from '../lib/constants';

const ACTIVITY_LABELS = {
  teaching_lecture:    'Teaching Lecture',
  case_report:         'Case Report',
  mortality_morbidity: 'Mortality & Morbidity',
  journal_club:        'Journal Club',
  quality_improvement: 'Quality Improvement Project',
  research_project:    'Research Project',
  other:               'Other',
};

const ACTIVITY_COLORS = {
  teaching_lecture:    '#2D6A8A',
  case_report:         '#3A7D6B',
  mortality_morbidity: '#8A4D5A',
  journal_club:        '#6B4D8A',
  quality_improvement: '#8A6B3A',
  research_project:    '#4D5A8A',
  other:               '#6B6B6B',
};

const STATUS = {
  pending:  { label: '⏳ Pending',  color: '#C4622A', bg: '#FFF8EE', border: '#F4DFA8' },
  approved: { label: '✓ Approved', color: '#1E5C40', bg: '#F0FFF6', border: '#A8DCC0' },
  rejected: { label: '✗ Rejected', color: '#8A2D2D', bg: '#FFF0F0', border: '#F4A8A8' },
};

export default function ActivityLog({ activities, onRefresh, isMobile }) {
  const [selected, setSelected] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const getLabel = (a) => a.activity_type === 'other'
    ? `Other: ${a.activity_type_other || '—'}`
    : ACTIVITY_LABELS[a.activity_type] || a.activity_type;

  const deleteActivity = async (id) => {
    if (!window.confirm('Delete this activity?')) return;
    setDeleting(true);
    await supabase.from('activities').delete().eq('id', id);
    setSelected(null);
    onRefresh();
    setDeleting(false);
  };

  if (selected) {
    const a = selected;
    const status = STATUS[a.approval_status];
    return (
      <div style={{ background: '#F7F4F0', minHeight: '100vh', paddingBottom: isMobile ? 80 : 0 }}>
        <div style={{ background: '#fff', padding: isMobile ? '14px 16px' : '16px 40px', borderBottom: '1px solid #E8E4E0', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0 }}>
          <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', color: '#2D6A8A', fontSize: 14, cursor: 'pointer', padding: 0 }}>← Back</button>
          <span style={{ fontFamily: "'DM Serif Display'", fontSize: isMobile ? 16 : 20, color: '#1A1A1F' }}>Activity Detail</span>
        </div>
        <div style={{ padding: isMobile ? 16 : '24px 40px', maxWidth: 700, margin: '0 auto' }}>
          <div style={{ padding: '8px 14px', borderRadius: 20, background: status?.bg, color: status?.color, border: `1px solid ${status?.border}`, fontSize: 13, fontWeight: 600, display: 'inline-block', marginBottom: 16 }}>{status?.label}</div>
          {a.director_comment && (
            <div style={{ background: '#F0FFF6', border: '1px solid #A8DCC0', borderRadius: 8, padding: '12px 14px', marginBottom: 16, fontSize: 13, color: '#1E5C40' }}>
              <strong>Director comment:</strong> "{a.director_comment}"
            </div>
          )}
          {[
            { label: 'Date', val: a.date },
            { label: 'Activity Type', val: getLabel(a) },
            { label: 'Title', val: a.title },
          ].map((row, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: 8, padding: '12px 14px', marginBottom: 8, display: 'flex', gap: 12 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#999', textTransform: 'uppercase', minWidth: 100 }}>{row.label}</span>
              <span style={{ fontSize: 14, color: '#333', flex: 1 }}>{row.val}</span>
            </div>
          ))}
          {a.approval_status === 'pending' && (
            <button onClick={() => deleteActivity(a.id)} disabled={deleting}
              style={{ marginTop: 16, padding: '11px 18px', background: '#FFF0F0', color: '#C42A2A', border: '1px solid #F4A8A8', borderRadius: 10, fontSize: 13, cursor: 'pointer', fontFamily: "'DM Sans'" }}>
              Delete
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingBottom: isMobile ? 80 : 0 }}>
      {activities.length === 0
        ? <div style={{ textAlign: 'center', padding: '40px 0', color: '#aaa', fontSize: 14 }}>No activities logged yet.</div>
        : <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {activities.map(a => {
              const status = STATUS[a.approval_status];
              const color  = ACTIVITY_COLORS[a.activity_type] || '#666';
              return (
                <div key={a.id} onClick={() => setSelected(a)}
                  style={{ background: '#fff', borderRadius: 10, padding: isMobile ? '12px 14px' : '14px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'pointer', borderLeft: `3px solid ${color}` }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 12, color: '#999', fontWeight: 600 }}>{a.date}</span>
                        <span style={{ fontSize: 11, background: color + '18', color: color, padding: '2px 8px', borderRadius: 20, fontWeight: 500 }}>{getLabel(a)}</span>
                      </div>
                      <div style={{ fontSize: 13, color: '#333', lineHeight: 1.5 }}>{a.title.slice(0, 100)}{a.title.length > 100 ? '…' : ''}</div>
                    </div>
                    <span style={{ fontSize: 10, fontWeight: 600, padding: '3px 8px', borderRadius: 20, background: status?.bg, color: status?.color, border: `1px solid ${status?.border}`, marginLeft: 10, whiteSpace: 'nowrap' }}>{status?.label}</span>
                  </div>
                </div>
              );
            })}
          </div>}
    </div>
  );
}
